export default {
      id: "icon-contentblockfour-usage",
      viewBox: "0 0 331 331",
      url: __webpack_public_path__ + "icons.svg#icon-contentblockfour",
      toString: function () {
        return this.url;
      }
    }